var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCafe(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 74,
    height: 74,
    viewBox: "0 0 74 74",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6316",
    "data-name": "Rectangle 6316",
    width: 38,
    height: 38,
    transform: "translate(0 0)",
    fill: "#c8d1ec"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_34922",
    "data-name": "Group 34922",
    transform: "translate(-5037 -5527)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6345",
    "data-name": "Rectangle 6345",
    width: 74,
    height: 74,
    rx: 12,
    transform: "translate(5037 5527)",
    fill: "#f1f5ff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_34894",
    "data-name": "Group 34894",
    transform: "translate(5055 5545)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_34862",
    "data-name": "Group 34862",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24352",
    "data-name": "Path 24352",
    d: "M0,18.164a1.432,1.432,0,0,1,1.5-.826q14.194.021,28.386.009c1.068,0,1.448.386,1.436,1.456,0,.244,0,.489,0,.771.777,0,1.529-.019,2.279.005a9.116,9.116,0,0,1,1.984.16A3.249,3.249,0,0,1,38,22.993a10.029,10.029,0,0,1-8.135,9.747,18.051,18.051,0,0,1-2.4.186.605.605,0,0,0-.519.265c-.511.676-1.041,1.337-1.594,2.044h.387q2.133,0,4.267,0a1.129,1.129,0,0,1,1.091,1.8A9.03,9.03,0,0,1,24,41.852a2.052,2.052,0,0,0-.249.063H7.571a1.763,1.763,0,0,0-.248-.063A9.083,9.083,0,0,1,2.235,39.6,9.941,9.941,0,0,1,0,36.646v-.52a1.287,1.287,0,0,1,1.4-.9c1.409.025,2.819.008,4.23.006.1,0,.208-.012.33-.019-.495-.616-.99-1.183-1.43-1.791a24.391,24.391,0,0,1-4.314-11.5C.132,21.245.072,20.557,0,19.871V18.164m2.28,1.427a.6.6,0,0,0-.017.1,24.529,24.529,0,0,0,2.064,8.9,16.673,16.673,0,0,0,4.795,6.456.8.8,0,0,0,.457.18q6.085.015,12.172,0a.574.574,0,0,0,.367-.117,29.114,29.114,0,0,0,2.287-2.266,20.216,20.216,0,0,0,3.944-8.255,24.784,24.784,0,0,0,.713-5Zm.993,17.883c.081.091.123.146.173.194a6.88,6.88,0,0,0,4.983,2.019q7.233.006,14.466,0a7.043,7.043,0,0,0,2.781-.543,6.727,6.727,0,0,0,2.384-1.672ZM31.126,21.8A26.258,26.258,0,0,1,28.5,30.66a6.844,6.844,0,0,0,3.38-1.012,7.675,7.675,0,0,0,3.891-6.663A1.082,1.082,0,0,0,34.7,21.809c-1.173-.019-2.347-.005-3.571-.005",
    transform: "translate(0 -3.912)",
    fill: "#c8d1ec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24353",
    "data-name": "Path 24353",
    d: "M11.154,11.149a1.212,1.212,0,0,1-1.138-.644,1.142,1.142,0,0,1,.126-1.186,4.369,4.369,0,0,0,.626-1.229,1.978,1.978,0,0,0-.639-1.844A4.13,4.13,0,0,1,9,3.057,4.13,4.13,0,0,1,10.186.372,1.094,1.094,0,0,1,11.75.29a1.081,1.081,0,0,1,.1,1.532,2.435,2.435,0,0,0-.625,1.236,2.109,2.109,0,0,0,.626,1.787,4.057,4.057,0,0,1,1.111,2.18,4.127,4.127,0,0,1-1.127,3.717,2.578,2.578,0,0,1-.686.407",
    transform: "translate(-2.028 0)",
    fill: "#c8d1ec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24354",
    "data-name": "Path 24354",
    d: "M19.433,7.626a1.932,1.932,0,0,0-.592-1.275,4.223,4.223,0,0,1-1.153-2.2A4.187,4.187,0,0,1,18.769.417,1.1,1.1,0,0,1,20.357.274a1.079,1.079,0,0,1,.091,1.587,2.023,2.023,0,0,0-.495,2.12,3.306,3.306,0,0,0,.643.98,4.278,4.278,0,0,1-.055,5.719,1.116,1.116,0,1,1-1.688-1.452,2.116,2.116,0,0,0,.58-1.6",
    transform: "translate(-3.974 0)",
    fill: "#c8d1ec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24355",
    "data-name": "Path 24355",
    d: "M28.418,11.149a1.211,1.211,0,0,1-1.146-.637A1.038,1.038,0,0,1,27.424,9.3a2.285,2.285,0,0,0,.635-1.422,2.2,2.2,0,0,0-.674-1.628A4.154,4.154,0,0,1,26.25,3.028a4.136,4.136,0,0,1,1.132-2.6A1.109,1.109,0,0,1,29,.286a1.084,1.084,0,0,1,.067,1.59A2.01,2.01,0,0,0,28.584,4a3.35,3.35,0,0,0,.649.976,4.26,4.26,0,0,1-.109,5.739,2.9,2.9,0,0,1-.706.436",
    transform: "translate(-5.921 0)",
    fill: "#c8d1ec"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCafe);
export default __webpack_public_path__ + "static/media/cafe.a1e20b530e610879d66be52ecf3aed6c.svg";
export { ForwardRef as ReactComponent };